import React, { useState, useEffect, useCallback } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { PaymentsTwoTone } from '@mui/icons-material';
import PropTypes from 'prop-types';

import axiosInstance from '../../api';
import StyledCard from '../../components/card/StyledCard';
import SERVER_API_URL from '../../config';
import LocaleText from '../../utils/localText';
import CustomSnackbar from '../../components/alerts/CustomSnackbar';
import { ethDate } from '../../utils/ethDate';

export default function UserPaymentInfo({ userId }) {
    const [paymentList, setPaymentList] = useState([]);
    const [notification, setNotification] = useState({});

    const columns = [
        { headerClassName: 'super-app-theme--header', field: 'fullName', width: 300, headerName: 'ሙሉ ስም' },
        { headerClassName: 'super-app-theme--header', field: 'currency', width: 100, headerName: 'ከረንሲ' },
        { headerClassName: 'super-app-theme--header', field: 'amount', width: 150, headerName: 'የብር መጠን' },
        {
            headerClassName: 'super-app-theme--header', field: 'billUrl',
            width: 150,
            headerName: 'ይክፈሉ',
            renderCell: (params) => (
                <Box
                    style={{
                        textDecoration: 'none',
                        boxShadow: 'none',
                        transition: 'box-shadow 0.3s ease, text-decoration 0.3s ease',
                        borderRadius: 20,
                        paddingLeft: 10,
                        paddingRight: 10,
                        backgroundColor: params.row.status === 'success' ? '#496E4D' : '#bb6868de',
                        pointerEvents: params.row.status === 'success' ? 'none' : 'auto',
                        color: 'darkblue',
                    }}
                >
                    <Typography display="flex">
                        <PaymentsTwoTone sx={{ fontSize: '18px', mr: 1, mt: 0.5 }} />
                        {params.row.status === 'success' && <Typography>ተከፍሏል</Typography>}
                        {params.row.status === 'pending' && (
                            <Typography >
                                አልተከፈለም
                            </Typography>
                        )}
                    </Typography>
                </Box>
            ),
        },
        {
            headerClassName: 'super-app-theme--header', field: 'createdAt',
            headerName: 'የተለቀቀበት ቀን',
            width: 250,
            valueGetter: (params) => ethDate(params.value),
        },
        {
            headerClassName: 'super-app-theme--header', field: 'email',
            width: 300,
            headerName: 'ኢሜል',
        },
        {
            headerClassName: 'super-app-theme--header', field: 'phone',
            width: 300,
            headerName: 'ስልክ ቁጥር',
        },
    ];

    const getMyPayments = useCallback(async () => {
        try {
            const response = await axiosInstance.post(`${SERVER_API_URL}/payment/findAll/${userId}`);

            if (response.status === 200) {
                setPaymentList(response.data);
            }
        } catch (error) {
            // console.log(error);
        }
    }, [userId]);

    useEffect(() => {
        getMyPayments();
    }, [getMyPayments]);

    return (
        <StyledCard
            sx={{
                '& .super-app-theme--header': {
                    backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.primary.darkMode.lighter : theme.palette.grey[400],
                }
            }}>
            {notification.message && <CustomSnackbar notification={notification} setNotification={setNotification} />}
            <DataGrid
                sx={{ p: 2, pt: 0, height: '75vh', '& .MuiDataGrid-row': { borderTopColor: (theme) => theme.palette.secondary.darker, borderWidth: 0.5, borderTopStyle: 'dashed' } }}
                rows={paymentList}
                columns={columns}
                pageSize={12}
                initialState={{
                    filter: {
                        filterModel: {
                            items: [],
                            quickFilterValues: [''],
                        },
                    },
                    pagination: { pageSize: 10 },
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                    },
                }}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                disableSelectionOnClickCell
                disableColumnFilter
                localeText={LocaleText.pagination}
            />
        </StyledCard>
    );
}

UserPaymentInfo.propTypes = {
    userId: PropTypes.string.isRequired,
}
